import React from 'react'

const OnlineIcon = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
      // fill="#565B5D"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M6 4H18V20H6V4ZM7 5H17V19H7V5Z" />
  </svg>
)

export default OnlineIcon
